import _extends from "@babel/runtime/helpers/extends";
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import Select from '@atlaskit/select';
import React from 'react';

const SelectInput = ({
  defaultValue,
  helperMessage,
  isCompact,
  isMulti,
  isRequired,
  label,
  name,
  onChange,
  options,
  placeholder,
  validate
}) => /*#__PURE__*/React.createElement(Field, {
  name: name,
  label: label,
  isRequired: isRequired,
  validate: validate,
  defaultValue: defaultValue
}, ({
  fieldProps,
  error
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, _extends({}, fieldProps, {
  isMulti: isMulti,
  options: options,
  defaultValue: defaultValue,
  placeholder: placeholder,
  spacing: isCompact ? 'compact' : 'default',
  onChange: e => {
    fieldProps.onChange(e);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }
})), error && /*#__PURE__*/React.createElement(ErrorMessage, null, error), helperMessage && /*#__PURE__*/React.createElement(HelperMessage, null, helperMessage)));

export default SelectInput;